export default "__VITE_ASSET__DMT_I9qF__"